@if (componentData$ | async; as data) {
  <div class="footer-container">
    <div class="footer-content">
      @if (node$ | async; as node) {
        @for (section of node?.children; track section) {
          <div class="footer-column">
            <!-- Section Title -->
            <h4>{{ section.title }}</h4>
            <ul class="list-unstyled m-0 p-0">
              @for (item of section.children; track item) {
                <li>
                  <cx-generic-link [url]="item.url" [target]="item.target" class="d-block">
                    {{ item.title }}
                  </cx-generic-link>
                </li>
              }
            </ul>
          </div>
        }
      }
    </div>
    <ng-container>
      <div class="footer-brand">
        <div class="footer-logo">Henry</div>
        <div class="footer-tagline">A Carlisle Company</div>
        <div class="join-conversation">Join the Conversation</div>
        <div class="social-icons">
          <a href="https://www.instagram.com/henry.company/" target="_blank" class="social-icon instagram" title="Instagram"></a>
          <a href="https://www.linkedin.com/onboarding/start/profile-location/new/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fhenry-company&source=coreg" target="_blank" class="social-icon linkedin" title="LinkedIn"></a>
          <a href="https://www.facebook.com/henrycompany/" target="_blank" class="social-icon facebook" title="Facebook"></a>
          <a href="https://www.youtube.com/user/HenryCompanyLLC" target="_blank" class="social-icon youtube" title="YouTube"></a>
        </div>
      </div>
    </ng-container>
  </div>
  <div>
    <cx-page-slot position="CwtFooter"></cx-page-slot>
  </div>
}